import { AppState } from 'Store'

const selectParams = (state: AppState) => state.iBro.bgLimits.bgLimitRequest.requestParams
const selectBgMessage = (state: AppState) => state.iBro.bgLimits.bgLimitRequest.bgMessage
const selectCurrentLimitRequest = (state: AppState) =>
	state.iBro.bgLimits.bgLimitRequest.currentLimitRequest
const selectLimitRequestMeta = (state: AppState) =>
	state.iBro.bgLimits.bgLimitRequest.limitRequestMeta
const selectLimitRequestData = (state: AppState) =>
	state.iBro.bgLimits.bgLimitRequest.limitRequestData
const selectLimitRequestList = (state: AppState) =>
	state.iBro.bgLimits.bgLimitRequest.limitRequestData.entries
const selectLimitRequestTotalEntries = (state: AppState) =>
	state.iBro.bgLimits.bgLimitRequest.limitRequestData.total_entries

export const bgLimitRequestSelector = {
	selectParams,
	selectBgMessage,
	selectCurrentLimitRequest,
	selectLimitRequestMeta,
	selectLimitRequestData,
	selectLimitRequestList,
	selectLimitRequestTotalEntries,
}
